<progress
  [class]="
    'password__indicator__progress password__indicator__progress--' + passwordLengthIndicator()
  "
  [value]="password()?.length || 0"
  [max]="MIN_NEW_PASSWORD_LENGTH"
></progress>
<div class="password-length-warning">
  {{ 'auth-warn-password' | translate: { minPwLength: MIN_NEW_PASSWORD_LENGTH } }}
  <span>{{ password()?.length || 0 }}/{{ MIN_NEW_PASSWORD_LENGTH }}</span>
</div>
